import clsx from "clsx";

import { Column } from "@/components/containers";
import { formatCurrency } from "@/utils/currency";

import styles from "./OnlySubscriptionPanel.module.scss";

type OnlySubscriptionPanelProps = {
  firstPrice: number;
  afterSecondPrice: number;
};

export function OnlySubscriptionPanel({
  firstPrice,
  afterSecondPrice,
}: OnlySubscriptionPanelProps) {
  return (
    <Column className="mg__bottom__m mg__bottom__s__pc">
      <Column className={styles.productCvSelect}>
        <input
          id="sp_subscription_radio"
          type="radio"
          checked
          readOnly
          className="radio__input expendable"
        />
        <label
          className={clsx("text__m text__bold", styles.productCvLabel)}
          htmlFor="sp_subscription_radio"
        >
          継続コース
        </label>

        <div className={styles.productCvBorder}>
          <dl className={styles.productCvPrice}>
            <dt className={clsx("text__s", styles.productCvPriceSubtotalText)}>小計</dt>
            <dd
              className={clsx(
                "text__xl text__bold text__right",
                styles.productCvPriceSubtotalValue
              )}
            >
              {formatCurrency(firstPrice)}
            </dd>
          </dl>
          <p className="text__s mg__bottom__m text__right">
            ２回目以降
            {formatCurrency(afterSecondPrice)}
          </p>
          <p className="text__s">
            初回20%OFF / 2回目以降10%OFF
            <br />
            次回以降お届け頻度 4週ごと
          </p>
        </div>
      </Column>
    </Column>
  );
}
